export default __webpack_public_path__ + "static/blueray_1-bc48e5a2a288019e4a324886840271fa.png";